import { Button } from "antd";
import { BsExclamationTriangle } from "react-icons/bs";

const EmptyAdsState: React.FC = () => {
    return (
        <div className="text-center py-16 bg-white rounded-lg shadow-sm">
            <div className="bg-gray-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <BsExclamationTriangle className="text-gray-500 text-4xl" />
            </div>
            <h3 className="text-xl font-medium text-gray-700">Aucune annonce disponible</h3>
            <p className="text-gray-500 mt-2 max-w-md mx-auto">
                Aucune annonce n'a été trouvée. Veuillez vérifier votre connexion ou actualiser la page.
            </p>
            <Button onClick={() => window.location.reload()} className="mt-6">
                Actualiser la page
            </Button>
        </div>
    );
};

export default EmptyAdsState; 